import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';

import { exportBrandProductsCsv } from '../../actions';
import withLowInventoryProductsCount from '../../hoc/withLowInventoryProductsCount';
import { SharedProductListContainer } from '../SharedProductList';
import columns from './columns';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const BrandProductListContainer = compose(
  SharedProductListContainer,
  connect(
    state => ({
      brand: state.auth.user.brand,
      canModifyProducts: canUserModifyProducts(state.auth.permissions),
      isCommissionBarber: false,
    }),
    {
      exportProductsToCsv: exportBrandProductsCsv,
    },
  ),
  withProps(props => ({
    canCreatePurchaseOrder: props.canModifyProducts,
    canSeeStockTaking: false,
    canSeeNewInventory: false,
    canSeeLowInventory: false,
    canExportToCsv: !!props.products.length,
    columns,
  })),
  withLowInventoryProductsCount,
  withHandlers({
    exportProductsToCsv: props => () => props.exportProductsToCsv(props.brand),
  }),
);

export default BrandProductListContainer;
